function getFocusableElements(t) {
    return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}

function initEventSummary(t) {
    t.querySelectorAll('[id^="Details-"] summary').forEach(t => {
        t.setAttribute("role", "button"), t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")), t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id), t.addEventListener("click", t => {
            t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"))
        }), t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape)
    })
}

initEventSummary(document);
const trapFocusHandlers = {};

function trapFocus(t, e = t) {
    var i = getFocusableElements(t), s = i[0], r = i[i.length - 1];
    removeTrapFocus(), trapFocusHandlers.focusin = e => {
        (e.target === t || e.target === r || e.target === s) && document.addEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.keydown = function (e) {
        "TAB" === e.code.toUpperCase() && (e.target !== r || e.shiftKey || (e.preventDefault(), s.focus()), (e.target === t || e.target === s) && e.shiftKey && (e.preventDefault(), r.focus()))
    }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), e.focus()
}

try {
    document.querySelector(":focus-visible")
} catch (t) {
    focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
    let t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        e = null, i = null;
    window.addEventListener("keydown", e => {
        t.includes(e.code.toUpperCase()) && (i = !1)
    }), window.addEventListener("mousedown", t => {
        i = !0
    }), window.addEventListener("focus", () => {
        e && e.classList.remove("focused"), i || (e = document.activeElement).classList.add("focused")
    }, !0)
}

function pauseAllMedia(t = document) {
    t.querySelectorAll(".js-youtube").forEach(t => {
        t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
    }), t.querySelectorAll(".js-vimeo").forEach(t => {
        t.contentWindow.postMessage('{"method":"pause"}', "*")
    }), t.querySelectorAll("video").forEach(t => t.pause()), t.querySelectorAll("product-model").forEach(t => {
        t.modelViewerUI && t.modelViewerUI.pause()
    })
}

function updateProductMediaStatus(t) {
    t.querySelectorAll(".product__media img").forEach(t => {
        t.complete ? addLoadedImageStatus(t) : t.onload = () => {
            addLoadedImageStatus(t)
        }
    })
}

function addLoadedImageStatus(t) {
    let e = t.parentElement;
    !e.classList.contains("loaded") && (e.classList.add("loaded"), e.nextElementSibling && setTimeout(() => e.nextElementSibling.remove(), 500))
}

function removeTrapFocus(t = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus()
}

function onKeyUpEscape(t) {
    if (!t.code || "ESCAPE" !== t.code.toUpperCase()) return;
    let e = t.target.closest("details[open]");
    if (!e) return;
    let i = e.querySelector("summary");
    e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus()
}

function loadColorSwatches() {
    window.loadedBackgroundColorSwatches = !0, fetch(window.Shopify.routes.root + "?section_id=background-color-swatches").then(t => t.text()).then(t => {
        document.body.appendChild(getDomHtmlFromText(t, "style"))
    })
}

function debounce(t, e) {
    let i;
    return (...s) => {
        clearTimeout(i), i = setTimeout(() => t.apply(this, s), e)
    }
}

function fetchConfig(t = "json", e = "POST") {
    return {method: e, headers: {"Content-Type": "application/json", Accept: `application/${t}`}}
}

function parseHtml(t) {
    return new DOMParser().parseFromString(t, "text/html")
}

function getDomHtmlFromText(t, e) {
    return parseHtml(t).querySelector(e)
}

function getInnerHtmlFromText(t, e) {
    return getDomHtmlFromText(t, e).innerHTML
}

function closeDetailsInAnimation(t) {
    let e, i = s => {
        void 0 === e && (e = s);
        let r = s - e;
        r < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
    };
    window.requestAnimationFrame(i)
}

void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function (t, e) {
    return function () {
        return t.apply(e, arguments)
    }
}, Shopify.setSelectorByValue = function (t, e) {
    for (var i = 0, s = t.options.length; i < s; i++) {
        var r = t.options[i];
        if (e == r.value || e == r.innerHTML) return t.selectedIndex = i, i
    }
}, Shopify.addListener = function (t, e, i) {
    t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
}, Shopify.postLink = function (t, e) {
    var i = (e = e || {}).method || "post", s = e.parameters || {}, r = document.createElement("form");
    for (var a in r.setAttribute("method", i), r.setAttribute("action", t), s) {
        var o = document.createElement("input");
        o.setAttribute("type", "hidden"), o.setAttribute("name", a), o.setAttribute("value", s[a]), r.appendChild(o)
    }
    document.body.appendChild(r), r.submit(), document.body.removeChild(r)
}, Shopify.CountryProvinceSelector = function (t, e, i) {
    this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var t = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
    }, initProvince: function () {
        var t = this.provinceEl.getAttribute("data-default");
        t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
    }, countryHandler: function (t) {
        var e = this.countryEl.options[this.countryEl.selectedIndex], i = JSON.parse(e.getAttribute("data-provinces"));
        if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none"; else {
            for (var s = 0; s < i.length; s++) {
                var e = document.createElement("option");
                e.value = i[s][0], e.innerHTML = i[s][1], this.provinceEl.appendChild(e)
            }
            this.provinceContainer.style.display = ""
        }
    }, clearOptions: function (t) {
        for (; t.firstChild;) t.removeChild(t.firstChild)
    }, setOptions: function (t, e) {
        for (var i = 0; i < e.length; i++) {
            var s = document.createElement("option");
            s.value = e[i], s.innerHTML = e[i], t.appendChild(s)
        }
        e.length
    }
}, Shopify.formatMoney = function (t, e) {
    function i(t, e) {
        return void 0 === t ? e : t
    }

    function s(t, e, s, r) {
        if (e = i(e, 2), s = i(s, ","), r = i(r, "."), isNaN(t) || null == t) return 0;
        var a = (t = (t / 100).toFixed(e)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + (a[1] ? r + a[1] : "")
    }

    "string" == typeof t && (t = t.replace(".", ""));
    var r = "", a = /\{\{\s*(\w+)\s*\}\}/, o = e || moneyFormat;
    switch (o.match(a)[1]) {
        case"amount":
            r = s(t, 2);
            break;
        case"amount_no_decimals":
            r = s(t, 0);
            break;
        case"amount_with_comma_separator":
            r = s(t, 2, ".", ",");
            break;
        case"amount_with_space_separator":
            r = s(t, 2, " ", ",");
            break;
        case"amount_with_period_and_space_separator":
            r = s(t, 2, " ", ".");
            break;
        case"amount_no_decimals_with_comma_separator":
            r = s(t, 0, ".", ",");
            break;
        case"amount_no_decimals_with_space_separator":
            r = s(t, 0, " ");
            break;
        case"amount_with_apostrophe_separator":
            r = s(t, 2, "'", ".")
    }
    return o.replace(a, r)
}, Shopify.showPrice = function (t, e = !1) {
    return e ? Shopify.formatMoney(t) : Shopify.formatMoney(t * Shopify.currency.rate)
};

class DrawerFixed extends HTMLElement {
    constructor() {
        super(), this.addEventListener("keyup", t => "Escape" === t.code && this.close(t)), this.stickyHeader = document.querySelector("sticky-header")
    }

    open(t) {
        t && this.setActiveElement(t), setTimeout(() => {
            this.classList.add("animate", "active")
        }), this.addEventListener("transitionend", () => {
            let t = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : this.classList.contains("drawer--cart") ? document.getElementById("CartDrawer") : document.getElementById("QuickAddDrawer"),
                e = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
            trapFocus(t, e)
        }, {once: !0}), document.body.classList.add("open-drawer-fixed")
    }

    getSectionInnerHTML(t, e = ".shopify-section") {
        return getInnerHtmlFromText(t, e)
    }

    getSectionDOM(t, e = ".shopify-section") {
        return getDomHtmlFromText(t, e)
    }

    setActiveElement(t) {
        this.activeElement = t
    }

    close(t) {
        this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("open-drawer-fixed"), setTimeout(() => {
            document.body.dispatchEvent(new CustomEvent("drawerClosed"))
        }, 500)
    }
}

class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", t => {
            "ESCAPE" === t.code.toUpperCase() && this.hide()
        }), this.classList.contains("media-modal") ? this.addEventListener("pointerup", t => {
            "mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide()
        }) : this.addEventListener("click", t => {
            t.target === this && this.hide()
        })
    }

    connectedCallback() {
        this.moved || (this.moved = !0, document.body.appendChild(this))
    }

    show(t) {
        this.removeAttribute("hidden"), this.openedBy = t;
        let e = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
    }

    hide() {
        this.classList.add("closing"), setTimeout(() => {

            sessionStorage.setItem("topbar-modal", "close");
            document.getElementById('redirect_bar').classList.remove('db');
            document.body.classList.remove('db');

            document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia(), this.classList.remove("closing")
        }, 1e3)
    }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let t = this.querySelector("button");
        if (!t) return;
        t.addEventListener("click", () => {
            let e = document.querySelector(this.dataset.modal);
            e && e.show(t)
        })
    }
}

customElements.define("modal-opener", ModalOpener);

class SliderComponent extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.init()
    }

    init() {
        this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = void 0 != this.dataset.outsidePrevButtonId ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsidePrevButtonId}`) : this.querySelector('button[name="previous"]'), this.nextButton = void 0 != this.dataset.outsideNextButtonId ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsideNextButtonId}`) : this.querySelector('button[name="next"]'), this.isAutoplay = "true" === this.slider.dataset.autoplay, this.autoplayButtonQuerySelector = ".slider__autoplay", this.autoPlayPausedClass = "slider__autoplay--paused", this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.slider && (this.sliderFirstItemNode = this.slider.querySelector(".slider__slide"), this.initPages(), this.nextButton && (this.onButtonClickHandler = this.onButtonClick.bind(this), this.prevButton.addEventListener("click", this.onButtonClickHandler), this.nextButton.addEventListener("click", this.onButtonClickHandler)), this.isAutoplay && this.setAutoPlay(), this.sliderControlButtons && (this.sliderControlLinksArray = Array.from(this.sliderControlButtons), this.sliderControlLinksArray.forEach(t => t.addEventListener("click", this.linkToSlide.bind(this)))), window.addEventListener("resize", debounce(t => {
            this.initPages()
        }), !0), this.slider.addEventListener("scroll", this.update.bind(this)))
    }

    disconnectedCallback() {
        this.nextButton && (this.prevButton.removeEventListener("click", this.onButtonClickHandler), this.nextButton.removeEventListener("click", this.onButtonClickHandler))
    }

    initPages() {
        if (this.sliderItemsToShow = Array.from(this.sliderItems).filter(t => t.clientWidth > 0), this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        let t = (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset;
        this.slidesPerPage = Math.floor(t), this.itemGap = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetWidth, this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage, (this.classList.contains("slider-component-full-width") || t - this.slidesPerPage > this.itemGap) && (this.totalPages += 1), this.sliderControlButtons.length && this.sliderControlButtons.forEach((t, e) => {
            t.classList.remove("hidden"), e >= this.totalPages && t.classList.add("hidden")
        }), this.update()
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
    }

    update() {
        let t = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage && this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", {
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        })), this.sliderControlButtons.length && (this.sliderControlButtons.forEach(t => {
            t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current")
        }), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0)), this.isAutoplay && this.autoplayButtonIsSetToPlay && this.play(), !this.enableSliderLooping && this.nextButton && (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
    }

    isSlideVisible(t, e = 0) {
        let i = this.slider.clientWidth + this.slider.scrollLeft - e;
        return t.offsetLeft + t.clientWidth - 1 <= i && t.offsetLeft >= this.slider.scrollLeft
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(this.autoplayButtonQuerySelector), this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.sliderAutoplayButton && this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
    }

    linkToSlide(t) {
        t.preventDefault();
        let e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({left: e})
    }

    autoPlayToggle() {
        this.togglePlayButtonState(), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }

    play() {
        this.slider.setAttribute("aria-live", "off"), clearTimeout(this.autoplay), this.autoplay = setTimeout(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearTimeout(this.autoplay)
    }

    togglePlayButtonState() {
        this.autoplayButtonIsSetToPlay ? (this.sliderAutoplayButton.classList.remove(this.autoPlayPausedClass), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow)) : (this.sliderAutoplayButton.classList.add(this.autoPlayPausedClass), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow))
    }

    autoRotateSlides() {
        let t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slider__slide").clientWidth;
        this.slider.scrollTo({left: t})
    }

    onButtonClick(t) {
        t.preventDefault();
        let e = t.currentTarget.dataset.step || 1;
        this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderItemOffset : this.slider.scrollLeft - e * this.sliderItemOffset, this.slider.scrollTo({left: this.slideScrollPosition})
    }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange)
    }

    onVariantChange(t) {
        this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses(), this.currentVariant ? (this.updateMedia(t), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), t => t.value)
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
    }

    updateMedia(t) {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        let e = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        e.forEach(t => t.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0));
        let i = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!i) return;
        let s = i.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        i.prepend(s)
    }

    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }

    updateShareUrl() {
        let t = document.getElementById(`Share-${this.dataset.section}`);
        t && t.updateUrl && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`, this.currentVariant)
    }

    updateVariantInput() {
        let t = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        t.forEach(t => {
            let e = t.querySelector('input[name="id"]');
            e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {bubbles: !0}))
        })
    }

    updateVariantStatuses() {
        let t = [...this.querySelectorAll('input[type="radio"]:checked, option:checked')],
            e = [...this.querySelectorAll(".product-form__input")];
        e.forEach((e, i) => {
            let s = [...e.querySelectorAll('input[type="radio"], option')], r = this.variantData.filter(e => {
                let s = !0;
                return t.forEach((t, r) => {
                    if (r != i && t.value != e.options[r]) return s = !1
                }), s
            }).map(t => t[`option${i + 1}`]);
            this.setInputAvailability(s, r)
        })
    }

    setInputAvailability(t, e) {
        t.forEach(t => {
            e.includes(t.getAttribute("value")) ? t.innerText = t.getAttribute("value") : t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", t.getAttribute("value"))
        })
    }

    updatePickupAvailability() {
        let t = document.querySelector("pickup-availability");
        t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
    }

    removeErrorMessage() {
        let t = this.closest("section");
        if (!t) return;
        let e = t.querySelector("product-form");
        e && e.handleErrorMessage()
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then(t => t.text()).then(t => {
            let e = new DOMParser().parseFromString(t, "text/html"),
                i = document.getElementById(`price-${this.dataset.section}`),
                s = e.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            s && i && (i.innerHTML = s.innerHTML);
            let r = document.getElementById(`price-${this.dataset.section}`),
                a = document.getElementById(`price-top-${this.dataset.section}`);
            r && r.classList.remove("visibility-hidden"), a && a.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant || !this.currentVariant.available, window.variantStrings.soldOut);
            let o = document.querySelectorAll(`.inventory-${this.dataset.section}`),
                n = e.querySelector(`.inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            n && o && o.forEach((t, e) => {
                t.innerHTML = n.innerHTML
            })
        })
    }

    toggleAddButton(t = !0, e, i = !0) {
        let s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s) return;
        let r = s.querySelector('[name="add"]'), a = s.querySelector('[name="add"] > span');
        if (r && (t ? (r.setAttribute("disabled", "disabled"), e && (a.textContent = e)) : (r.removeAttribute("disabled"), a.textContent = window.variantStrings.addToCart), !i)) return
    }

    setUnavailable() {
        let t = document.getElementById(`product-form-${this.dataset.section}`), e = t.querySelector('[name="add"]'),
            i = t.querySelector('[name="add"] > span'), s = document.getElementById(`price-${this.dataset.section}`),
            r = document.getElementById(`price-top-${this.dataset.section}`);
        e && (i.textContent = window.variantStrings.unavailable, s && s.classList.add("visibility-hidden"), r && r.classList.add("visibility-hidden"))
    }

    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }

    getSoldoutVariants() {
        return void 0 == this.soldoutVariants && (this.soldoutVariants = this.getVariantData().filter(t => !t.available)), this.soldoutVariants
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super(), this.optionSelector = "fieldset", this.optionValuesSelector = "label", this.soldOutClass = "soldout"
    }

    updateOptions() {
        let t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked).value)
    }

    connectedCallback() {
        this.loadBackgroundColorSwatches()
    }

    onVariantChange(t) {
        super.onVariantChange(t), this.updateSoldoutValues(), this.currentVariant && this.updateOptionLabel(t)
    }

    setInputAvailability(t, e) {
        t.forEach(t => {
            e.includes(t.getAttribute("value")) ? t.classList.remove("disabled") : t.classList.add("disabled")
        })
    }

    updateOptionLabel(t) {
        this.querySelectorAll(".product-form__input__option-value").forEach((t, e) => {
            t.textContent = this.currentVariant.options[e]
        })
    }

    updateSoldoutValues() {
        let t = this.getSoldoutVariants(), e = this.querySelectorAll('input[type="radio"]:checked');
        t.length > 0 && this.querySelectorAll(this.optionSelector).forEach((i, s) => {
            let r = t.filter(t => {
                let i = !0;
                return e.forEach((e, r) => {
                    if (r != s && e.value != t.options[r]) return i = !1
                }), i
            }), a = r.map(t => t.options[s]);
            i.querySelectorAll(this.optionValuesSelector).forEach(t => {
                t.classList.remove(this.soldOutClass);
                let e = t.parentElement.querySelector(`#${t.htmlFor}`).value;
                a.includes(e) && t.classList.add(this.soldOutClass)
            })
        })
    }

    loadBackgroundColorSwatches() {
        !window.loadedBackgroundColorSwatches && this.querySelectorAll(".product-form__input__radio-label--color").length > 0 && loadColorSwatches()
    }
}

customElements.define("variant-radios", VariantRadios);
const deferredMediaObserver = new IntersectionObserver((t, e) => {
    t.forEach(t => {
        t.isIntersecting ? t.target.loadContent(!1) : t.target.pause()
    })
});

class DeferredMedia extends HTMLElement {
    constructor() {
        super(), this.isPlaying = !1;
        let t = this.querySelector('[id^="Deferred-Poster-"]');
        if (!t) return;
        t.addEventListener("click", this.loadContent.bind(this)), this.dataset.autoplay && deferredMediaObserver.observe(this)
    }

    loadContent(t = !0) {
        if (!this.deferredElement) {
            let e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), this.deferredElement = this.appendChild(e.querySelector("video, model-viewer, iframe"))
        }
        this.deferredElement && (t && this.deferredElement.focus(), "VIDEO" == this.deferredElement.nodeName && this.deferredElement.getAttribute("autoplay") && (this.deferredElement.play(), this.isPlaying = !0))
    }

    pause() {
        this.deferredElement && this.isPlaying && (window.pauseAllMedia(this), this.isPlaying = !1)
    }
}

customElements.define("deferred-media", DeferredMedia);

class BtStorageUtil {
    static set(t, e, i) {
        i ? sessionStorage.setItem(`bt-${t}`, "object" == typeof e ? JSON.stringify(e) : e) : localStorage.setItem(`bt-${t}`, "object" == typeof e ? JSON.stringify(e) : e)
    }

    static get(t, e, i) {
        let s = i ? sessionStorage.getItem(`bt-${t}`) : localStorage.getItem(`bt-${t}`);
        return e ? JSON.parse(s) : s
    }

    static remove(t, e) {
        e ? sessionStorage.removeItem(`bt-${t}`) : localStorage.removeItem(`bt-${t}`)
    }
}
